import React from "react";
import PropTypes from "prop-types";

import { ButtonLinkStyled } from "../../../../components/common/Buttons/Button.Style";

import * as S from "./ProductContent.style";

export const ProductContent = ({ hiddenBorder, description, lists }) => {
  return (
    <S.ProductContentContainer>
      {description ? (
        <S.ProductContentDescription>{description}</S.ProductContentDescription>
      ) : null}

      <S.ProductContentList $hiddenBorder={hiddenBorder}>
        {Array.isArray(lists)
          ? lists.map((listItem) => (
              <S.ProductContentItem key={listItem?.id} className="tab-item">
                {listItem?.title && listItem?.description ? (
                  <S.ProductContentItemHeader>
                    <S.ProductContentTitle>
                      {listItem?.title}
                    </S.ProductContentTitle>

                    <S.ProductContentDescription>
                      {listItem?.description}
                    </S.ProductContentDescription>
                  </S.ProductContentItemHeader>
                ) : null}

                {Array.isArray(listItem?.links)
                  ? listItem?.links.map((linkItem) => (
                      <S.ProductContentItemLink key={linkItem?.id}>
                        <ButtonLinkStyled
                          as="a"
                          variant="text"
                          href={linkItem.href}
                          target={linkItem?.target}
                          onClick={(event) => {
                            if (linkItem.onClick) {
                              event.preventDefault();
                              linkItem.onClick();
                            }
                          }}
                        >
                          <linkItem.icon size={32} width={32} height={32} />
                          {linkItem?.title}
                        </ButtonLinkStyled>

                        <S.ProductContentItemLinkDescription>
                          {linkItem?.description}
                        </S.ProductContentItemLinkDescription>
                      </S.ProductContentItemLink>
                    ))
                  : null}
              </S.ProductContentItem>
            ))
          : null}
      </S.ProductContentList>
    </S.ProductContentContainer>
  );
};

ProductContent.propTypes = {
  hiddenBorder: PropTypes.bool,
  description: PropTypes.element.isRequired,
  lists: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      icon: PropTypes.elementType.isRequired,
      title: PropTypes.string,
      description: PropTypes.string,
    })
  ),
};

ProductContent.defaultProps = {
  lists: [],
  hiddenBorder: false,
};
